// Tools - Users
import Axios from 'axios';
import moment from 'moment';

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_CHARTERS = 1;
const ADMIN_LVL_LEAGUES = 2;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const ADMIN_LVL_ADMINLIMIT = 20;
const ADMIN_LVL_NOACCESS = 99;

// getDbFullUserData
const getDbFullUserData = function(authUser, clsIds = {}, callback) {
  // console.log("USERS - getDbFullUserData", authUser, clsIds);
  if (!authUser || !authUser.sub) {
    console.error("getDbFullUserData: INVALID USER");
    callback(null);
    return;
  }

  clsIds = clsIds || {};
  clsIds.charterId ??= "0";
  clsIds.leagueId ??= "0";
  clsIds.seasonId ??= "0";

  const payload = {
    authUser: {
      sub: authUser.sub,
      name: authUser.name || '',
      email: authUser.email || '',
      picture: authUser.picture || ''
    },
    clsIds: {
      charterId: clsIds.charterId,
      leagueId: clsIds.leagueId,
      seasonId: clsIds.seasonId
    }
  };

  Axios.post('/api/users/fullUserData', payload)
    .then(res => {
      // console.log("RESULT getDbFullUserData :", res.data);
      
      const connectedUser = {
        ...res.data,

        // getters
        get isMasterAdmin() { return this.adminValidatedLevel === ADMIN_LVL_MASTER; },
        get isLeagueAdmin() { return this.adminValidatedLevel <= ADMIN_LVL_LEAGUES; },
        get isSeasonAdmin() { return this.adminValidatedLevel <= ADMIN_LVL_SEASONS; },
        get isScoresheetAdmin() { return this.adminValidatedLevel <= ADMIN_LVL_SCORESHEETS; },
        get isAdmin() { return this.adminValidatedLevel <= ADMIN_LVL_ADMINLIMIT; },
        get isQvneaMaster() { return this.user?.charterAdmin?.includes('QVNEA-MASTER') || false; },
        get isQvneaAssist() { return this.user?.charterAdmin?.includes('QVNEA-ASSIST') || false; }
      }
/*
      if (connectedUser.exists && connectedUser.user?._id) {
        setConnection(connectedUser.user._id)
      }
*/
      callback(connectedUser)
    })
    .catch(err => {
      console.log("ERROR getDbFullUserData");
      console.error("ERROR getDbFullUserData :", err);
      callback(null);
    });

};

const setConnection = function(userId, callback) {
  
  console.log("USERS - setConnection: userId", userId)

  Axios.post('/api/users/setConnection', { userId: userId })
    .catch(err => console.error('Erreur updateLastConnection:', err));
};

export default {
  getDbFullUserData,
  setConnection
};
